import { render, staticRenderFns } from "./TikTok_form.vue?vue&type=template&id=d145da96&"
import script from "./TikTok_form.vue?vue&type=script&lang=js&"
export * from "./TikTok_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports